/* eslint-disable react/no-unknown-property */
import { useGLTF } from '@react-three/drei';

export default function Model() {
  const { scene: model } = useGLTF('model/child.glb');

  return <primitive object={model} />;
}
